import React, { useState, useEffect } from 'react';
import { createGroup, updateGroupInfo, setDefaultGroup, deleteGroup } from '../composables/fetchAPI';
import toast from 'react-hot-toast'; // Import toast notification
import { on } from 'events';

interface CreateGroupPopupProps {
  onClose: () => void;
  onGroupUpdated: () => void;
  mode: 'add' | 'edit'; // Determines whether the popup is for adding or editing
  groupData?: { id: string; name: string; emoji?: string; color?: string; isDefault?: boolean }; // Existing group data for editing
}

export default function AddEditGroupPopup({
  onClose,
  onGroupUpdated,
  mode,
  groupData,
}: CreateGroupPopupProps) {
  const [groupName, setGroupName] = useState('');
  const [isDefault, setIsDefault] = useState(false);

  useEffect(() => {
    if (mode === 'edit' && groupData) {
      setGroupName(groupData.name); // Pre-fill the group name for editing
      setIsDefault(groupData.isDefault || false); // Set the default status
    }
  }, [mode, groupData]);

  const handleSaveGroup = async () => {
    try {
      if (groupName.trim() === '') {
        toast.error('โปรดระบุชื่อกลุ่ม'); // Show error toast alert
        return; // Prevent saving with an empty name
      }

      if (mode === 'add') {
        await createGroup({ name: groupName });
      } else if (mode === 'edit' && groupData?.id) {
        await updateGroupInfo(groupData.id, { name: groupName });
      }

      onGroupUpdated(); // Refresh the group list in the parent component
      onClose(); // Close the popup
    } catch (error) {
      console.error(`Failed to ${mode === 'add' ? 'create' : 'update'} group:`, error);
      toast.error('เกิดข้อผิดพลาดในการบันทึกกลุ่ม'); // Show error toast alert for failure
    }
  };

  const handleSetDefault = async () => {
    try {
      if (groupData?.id) {
        await setDefaultGroup(groupData.id); // Call the API to set the group as default
        setIsDefault(true); // Update the local state
        onGroupUpdated(); // Refresh the group list in the parent component
        onClose();
      }
    } catch (error) {
      console.error('Failed to set default group:', error);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSaveGroup(); // Trigger save when Enter is pressed
    }
  };
  const handleDeleteGroup = async () => {
    try {
      if (groupData?.id) {
        await deleteGroup(groupData.id); // Call the API to delete the group
        onGroupUpdated(); // Refresh the group list in the parent component
        onClose(); // Close the popup
      }
    } catch (error: any) {
      console.error('Failed to delete groups:', error);
      toast.error('ลบไม่สำเร็จ กรุณาตั้ง Default กับ Group อื่น'); // Show toast alert

    }
  };
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-0"
      style={{
    zIndex: 50, // เพิ่ม z-index เพื่อให้แสดงอยู่ด้านบน
  }}
      onClick={onClose}
    >
      <div
        className=" p-6 rounded shadow-lg w-96"
        style={{ background: 'var(--component-bg-color)' }}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the popup
      >
        <div className="flex justify-start items-center mb-4 ">
          <h3 className="text-lg font-bold "
            style={{ color: 'var(--text-color)' }}
          >
            {mode === 'add' ? 'เพิ่มกลุ่มรายการโปรด' : 'แก้ไขกลุ่มรายการโปรด'}
          </h3>
          {mode === 'edit' &&
            <button
              onClick={handleDeleteGroup}
              className="bg-red-500 text-white ml-2 px-2 py-1 rounded hover:bg-red-600"
            >
              ลบกลุ่ม
            </button>
          }
        </div>

        <input
          type="text"
          placeholder="โปรดระบุชื่อกลุ่ม"
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
          onKeyDown={handleKeyDown} // Add keydown listener for Enter key
          className="border border-gray-300 rounded px-4 py-2 w-full mb-4 text-black"
        />
        {mode === 'edit' && (
          <div className="flex items-center justify-start mb-4">
            <span className="text-sm "
              style={{ color: 'var(--secondary-text-color)' }}
            >
              {isDefault ? 'Default' : 'Not Default'}:
            </span>
            {!isDefault && (
              <button
                onClick={handleSetDefault}
                className="bg-blue-500 text-white ml-2 px-2 py-1 rounded hover:bg-blue-600"
              >
                ตั้งกลุ่มเป็นค่าตั้งต้น
              </button>
            )}
          </div>
        )}
        <div className="flex justify-end space-x-2">
           <button
            onClick={onClose}
            className="bg-gray-500 text-black px-4 py-2 rounded font-bold hover:bg-gray-600"
            style={{
              backgroundColor: '#374151', // Gray color for "Cancel" button
              color: '#FFFFFF', // White text
            }}
          >
            ยกเลิก
          </button>
          <button
            onClick={handleSaveGroup}
            className="bg-green-500 text-black px-4 py-2 rounded font-bold hover:bg-green-600"
            style={{
              backgroundColor: '#22C55E', // Green color for "Create" button
              color: '#000000', // Black text
            }}
          >
            {mode === 'add' ? 'บันทึก' : 'บันทึก'}
          </button>
         
        </div>
      </div>
    </div>
  );
}